export default {
  title: 'Drukke modus',
  form: {
    has_busy_mode: {
      label: 'Drukke modus',
    },
    busy_mode_minutes: {
      label: 'Hoeveel tijd wilt u toevoegen aan uw reguliere bereidingstijd?',
      options: {
        10: '10 min',
        15: '15 min',
        20: '20 min',
        25: '25 min',
        30: '30 min',
        45: '45 min',
        60: '1 uur',
      },
    },
  },
  buttons: {
    save: 'Opslaan',
  },
  toasts: {
    failed_to_save_changes: 'Wijzigingen opslaan mislukt',
    changes_got_saved: 'Wijzigingen succesvol opgeslagen',
  },
};
